/**
 * Extracts a slug value from pathname by matching it against a route template.
 * Route templates use placeholders like {service_company_slug} and {id}.
 *
 * @param pathname - Current pathname (e.g. window.location.pathname)
 * @param routeTemplate - Route with placeholders (e.g. "/{service_company_slug}/job-series/{id}/")
 * @param slugName - Name of the placeholder to extract (e.g. "id")
 * @returns The extracted value, or "" if not found
 */
function escapeRegexLiteral(s: string): string {
    return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

export default function extractSlugFromPathname(pathname: string, routeTemplate: string, slugName: string): string {
    const parts = routeTemplate.split(/\{([^}]+)\}/)
    const slugNames: string[] = []
    const regexParts: string[] = []
    for (let i = 0; i < parts.length; i++) {
        if (i % 2 === 0) {
            regexParts.push(escapeRegexLiteral(parts[i]))
        } else {
            slugNames.push(parts[i])
            regexParts.push("([^/]+)")
        }
    }
    const regex = new RegExp(`^${regexParts.join("")}$`)
    const match = pathname.match(regex)
    const index = slugNames.indexOf(slugName)
    if (match && index >= 0 && index + 1 < match.length) {
        return match[index + 1] ?? ""
    }
    return ""
}
